import Crud from './crud'
import Vue from 'vue';
import configs from '@/configs';
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';

var crud = new Crud('notifications', 'thông báo');

const state = {
    ...crud.state,
    top5: []
};

const getters = {
    ...crud.getters
};

const actions = {
    ...crud.actions,
    getTop5({ commit }) {
        return new Promise((resolve, reject) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            };
            Vue.http.get(`${configs.API}/api/notifications/top5/`, req).then(res => {
                if (res && res.data && res.data.data) {
                    commit('setTop5', res.data.data);
                    resolve(res.data.data);
                } else {
                    resolve([]);
                }
            }, error => {
                reject(error);
            });
        });
    },
    markRead({ commit, dispatch }, id) {
        return new Promise((resolve, reject) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            };
            Vue.http.post(`${configs.API}/api/notifications/${id}/read/`, {}, req).then(res => {
                dispatch('getTop5');
                refreshResource();
                resolve(res.data);
            }, error => {
                reject(error);
            });
        });
    },
    markAllRead({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            const token = this.state.authentication.token;
            const req = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            };
            Vue.http.post(`${configs.API}/api/notifications/read-all/`, {}, req).then(res => {
                sendSuccessNotice('Đã đánh dấu đọc tất cả thông báo.');
                dispatch('getTop5');
                refreshResource();
                resolve(res.data);
            }, error => {
                sendErrorNotice('Không thể đánh dấu đọc tất cả.');
                reject(error);
            });
        });
    }
};

const mutations = {
    ...crud.mutations,
    setTop5(state, data) {
        state.top5 = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
